export enum SponsorSearchCriteria	{
    FBOID = 1,
    EmailAddress = 2,
    FirstName = 3,
    LastName = 4,
    Country = 5,
    Language = 6,
    ZipCode = 7,
    Facebook = 8,
    Instagram = 9,
    Twitter = 10,
    Pinterest = 11,
    LinkedIn = 12,
    Other = 13,
    Google = 14,
    Bing = 15,
    Yahoo = 16,
    Ask = 17,
    ID = 18,
    FullName = 19,
    City = 20,
    State = 21,
    Email = 22,
    Phone = 23
  }



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/sponsor-search-criteria.enum.ts